import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $timeout, LocaleService, submissionViewModel, StateUtils, ViewModelService, LoadSaveService, QuoteService, ModalService) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;

    ctrl.init = function () {

        $scope.submissionVM = submissionVM;
        $scope.submissionVM.baseData.value.mSFLocations = $filter('orderBy')($scope.submissionVM.baseData.value.mSFLocations, 'locationNum', false);
        $scope.view = ViewModelService.create($scope.submissionVM.baseData.value, 'pc', 'edge.capabilities.quote.submission.base.dto.QuoteBaseDataDTO');
        $scope.editLocationView = null;
    };
    /**
     * Check whether vehicles exist
     * @returns {boolean}
     */
    $scope.locationsExist = function () {
        return $scope.view.mSFLocations && !($scope.view.mSFLocations.length === 0);
    };

    /**
     * Check whether one vehicles exist
     * @returns {boolean}
     */
    $scope.onlyOnelocationsExists = function () {
        return $scope.view.mSFLocations && $scope.view.mSFLocations.length === 1;
    };

    /**
     * Begin editing an entry
     */
    $scope.onEdit = function () {
        ctrl.cleanAdd();
        ctrl.resetFlags();
        $scope.isEditing = true;
    };
    $scope.inPreCommitStage = function () {
        return $scope.isAddingNew || ($scope.isEditing || $scope.isRemoving) && $scope.selectedEntry > -1;
    };

    /**
     * Select an entry
     * @param {Number} index
     */
    $scope.selectEntry = function (index, location) {
        var locations = $scope.view.mSFLocations;
        var locationView = locations.getElement(index);
        $scope.locationView = locations.getElement(index);
        $scope.selectedLocation = locationView.value;
        $scope.selectedEntry = index;
    };
    /**
     * Select primary
     * @param {Number} index
     */
    $scope.selectPrimary = function (index) {
        $scope.selectedPrimary = index;
        var locationIndex = 0;
        angular.forEach($scope.view.mSFLocations.value, function (value, key) {
            if (locationIndex == $scope.selectedPrimary) {
                $scope.view.mSFLocations.value[locationIndex].primaryLocation = true;
            } else {
                $scope.view.mSFLocations.value[locationIndex].primaryLocation = false;
            }
            locationIndex++;
        });
        ctrl.saveChanges($scope.view.mSFLocations.value[$scope.selectedPrimary], 'updatePrimary');
    };

    /**
     * Populates a new entry with default values for use in the new entry form
     */
    function setDefaultNewEntry() {
        var location = {
            locationNum: $scope.view.mSFLocations.value.length + 1,
            state: 'MT'
        };
        $scope.locationView = ViewModelService.create(location, 'pc', 'edge.capabilities.address.dto.MSFPolicyLocationDTO');
        $scope.selectedLocation = $scope.locationView.value;
    }

    /**
     * Cancels add operation if they are active
     */
    ctrl.cleanAdd = function () {

        if ($scope.isAddingNew) {
            $scope.cancelNewEntry();
        }
    };

    /**
     * Begin adding a new entry
     */
    $scope.onAddNew = function () {
        ctrl.cleanAdd();
        setDefaultNewEntry();
        ctrl.resetFlags();
        $scope.isAddingNew = true;
    };
    /**
     * Begin removing entries
     */
    $scope.onRemove = function () {
        ctrl.cleanAdd();
        ctrl.resetFlags();
        $scope.isRemoving = true;
    };

    /**
     * Delete an entry
     * @param {Number} index
     */
    $scope.deleteEntry = function (index) {
        if (index > -1) {

            ctrl.saveChanges($scope.view.mSFLocations.value[index], 'delete');
            $scope.view.mSFLocations.value.splice(index, 1);
            $scope.selectedEntry = -1;

            if ($scope.view.mSFLocations.value.length <= 1) {
                $scope.cancelRemove();
            }
        }
    };

    /**
     * Stop removing entries
     */
    $scope.cancelRemove = function () {
        $scope.isRemoving = false;
    };
    /**
     * Cancel the new entry form
     */
    $scope.cancelNewEntry = function () {
        $scope.isAddingNew = false;
    };

    /**
     * Submit the new entry form
     */
    $scope.submitNewEntry = function (locationsForm, locationView) {
        console.log(locationsForm.$invalid);
        locationsForm.submitted = true;
        $scope.worksubmitted = false;
        if (locationsForm.$invalid) {
            $scope.worksubmitted = true;
            return $scope.worksubmitted;
        }
        //if(locationView.primaryAddress.country.value.code!="CA"){
        var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
        if (locationView.postalCode.value != '' && !regexp.test(locationView.postalCode.value)) {
            $scope.error_exist = true;
            return $scope.error_exist;
        } else {
            $scope.error_exist = false;
        }
        //  }

        /* if(locationView.primaryAddress.country.value.code=="CA"){
         	var regexp = /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/;
             if (locationView.primaryAddress.postalCode.value!='' && !regexp.test(locationView.primaryAddress.postalCode.value))
               {
                 $scope.error_exist = true;
                 return $scope.error_exist;
               }
             else
               {
             	$scope.error_exist = false;
               }
         }*/

        var phoneNumber = angular.element('#phone').val();

        $scope.selectedLocation = locationView.value;
        if (phoneNumber != undefined && phoneNumber != null && phoneNumber.trim() != '') {
            $scope.selectedLocation.phoneExtension = phoneNumber.split('x')[1].trim().replace(/\D/g, '');
            $scope.selectedLocation.phone = phoneNumber.split('x')[0].trim().replace(/\D/g, '');
        }

        //$scope.view.mSFLocations.value.push($scope.selectedLocation);
        $scope.isAddingNew = false;
        ctrl.saveChanges($scope.selectedLocation, 'add');
    };

    $scope.updateEntry = function (locationsForm, locationView) {
        console.log('edit location view');
        console.log(locationView);

        locationsForm.submitted = true;
        $scope.worksubmitted = false;
        if (locationsForm.$invalid) {
            $scope.worksubmitted = true;
            return $scope.worksubmitted;
        }

        //if(locationView.primaryAddress.country.value.code!="CA"){
        var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
        if (locationView.postalCode.value != '' && !regexp.test(locationView.postalCode.value)) {
            $scope.error_exist = true;
            return $scope.error_exist;
        } else {
            $scope.error_exist = false;
        }
        //}

        /*if(locationView.primaryAddress.country.value.code=="CA"){
        	var regexp = /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/;
            if (locationView.primaryAddress.postalCode.value!='' && !regexp.test(locationView.primaryAddress.postalCode.value))
              {
                $scope.error_exist = true;
                return $scope.error_exist;
              }
            else
              {
            	$scope.error_exist = false;
              }
        }
        */
        var phoneNumber = angular.element('#phone').val();

        $scope.view.mSFLocations.value[$scope.selectedEntry] = locationView.value;

        if (phoneNumber != undefined && phoneNumber != null && phoneNumber.trim() != '') {
            $scope.view.mSFLocations.value[$scope.selectedEntry].phoneExtension = phoneNumber.split('x')[1].trim().replace(/\D/g, '');
            $scope.view.mSFLocations.value[$scope.selectedEntry].phone = phoneNumber.split('x')[0].trim().replace(/\D/g, '');
        }
        ctrl.saveChanges($scope.view.mSFLocations.value[$scope.selectedEntry], 'edit');
        $scope.isEditing = false;

        $scope.selectedEntry = -1;
    };

    /**
     * Stop editing an entry
     */
    $scope.cancelEdit = function () {
        $scope.isEditing = false;
        if ($scope.selectedEntry !== -1) {
            var selectedLocation = $scope.view.mSFLocations.value[$scope.selectedEntry];
            Object.assign(selectedLocation, $scope.modelBackup);
        }
        $scope.selectedEntry = -1;
    };

    /**
     * Resets all of the flags to their default false state
     */
    ctrl.resetFlags = function () {
        $scope.isRemoving = false;
        $scope.isReplacing = false;
        $scope.isEditing = false;
        $scope.isAddingNew = false;
        $scope.selectedEntry = -1;
    };

    /**
     * Save pending policy changes in PC, shows error dialog on failure
     * @returns {Promise}
     */
    ctrl.saveChanges = function (location, action) {

        /**
         * updating to PC
         */
        $scope.savePromise = QuoteService.policyLocationChange($scope.submissionVM.value, location, action).then(function (data) {
            data.baseData.mSFLocations = $filter('orderBy')(data.baseData.mSFLocations, 'locationNum', false);
            $scope.view = ViewModelService.create(data.baseData, 'pc', 'edge.capabilities.quote.submission.base.dto.QuoteBaseDataDTO');
            //update covered employees for state coverage screen
            $scope.submissionVM.baseData.mSFCoveredEmployees_EXT.value = $scope.view.mSFCoveredEmployees_EXT.value;
        }, function () {
            ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
        });;
    };
    //next method
    ctrl.next = function (nextFn, form) {
        submissionVM.baseData.mSFIsLocation_EXT.value = true;
        nextFn(submissionVM, form.valid);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'submissionViewModel', 'StateUtils', 'ViewModelService', 'qnb.LoadSaveService', 'quoteService', 'ModalService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/controllers/WCLocationsCtrl.js
// module id = 1296
// module chunks = 0